const $ = window.jQuery;
import _each from 'lodash/each';
import _throttle from 'lodash/throttle';
import 'slick-carousel';

const blankCard = `<article class="card card--blank" style="width: 100%; display: inline-block;"></article>`;

$(() => {
    let resetting = false;

    function handleArrowClasses(
        prevActive,
        nextActive,
        $prevArrow,
        $nextArrow,
    ) {
        if (prevActive) {
            $prevArrow.removeClass('--disabled');
            $prevArrow.prop('disabled', false);
        } else if (!prevActive) {
            $prevArrow.addClass('--disabled');
            $prevArrow.prop('disabled', true);
        }

        if (nextActive) {
            $nextArrow.removeClass('--disabled');
            $nextArrow.prop('disabled', false);
        } else if (!nextActive) {
            $nextArrow.addClass('--disabled');
            $nextArrow.prop('disabled', true);
        }
    }

    const $card_sliders = $('.card-slider');

    _each($card_sliders, card_slider => {
        const $card_slider = $(card_slider).find('.card-slider__slider');
        const $arrows = $(card_slider)
            .find('.card-slider__arrows')
            .first();

        let args = {
            infinite: false,
            appendArrows: $arrows,
            prevArrow: `<button class="bleeding-slider__button slick-prev --disabled"><i class="icon-arrow-left"></i></button>`,
            nextArrow: `<button class="bleeding-slider__button slick-next"><i class="icon-arrow-right"></i></button>`,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        };

        $card_slider.append(blankCard);
        $card_slider.addClass('--blank-appended');

        $card_slider.on(
            'beforeChange',
            (event, slick, currentSlide, nextSlide) => {
                let { slideCount } = slick;
                const slidesToShow = window.innerWidth >= 1024 ? 3 : 2;
                const $prevArrow = $arrows.find('.slick-prev');
                const $nextArrow = $arrows.find('.slick-next');
                const hasExtraSlide = window.innerWidth >= 600;

                if (hasExtraSlide) {
                    slideCount = slideCount - 1;
                }

                const prevActive = currentSlide === 0 || nextSlide !== 0;
                const nextActive = nextSlide + slidesToShow < slideCount;

                if (resetting) {
                    resetting = false;
                    return;
                }

                handleArrowClasses(
                    prevActive,
                    nextActive,
                    $prevArrow,
                    $nextArrow,
                );
            },
        );

        function showOrHideArrows(slider) {
            const { slideCount } = slider[0].slick;

            if (slideCount <= 4 && window.innerWidth >= 1024) {
                $arrows.hide();
            } else if (slideCount <= 3 && window.innerWidth < 1024) {
                $arrows.hide();
            } else {
                $arrows.show();
            }
        }

        const slider = $card_slider.slick(args);

        showOrHideArrows(slider);

        $(window).on('resize orientationchange', function() {
            const $prevArrow = $arrows.find('.slick-prev');
            const $nextArrow = $arrows.find('.slick-next');

            showOrHideArrows(slider);
            $(slider).slick('slickGoTo', 0);

            $prevArrow.addClass('--disabled');
            $nextArrow.removeClass('--disabled');

            resetting = true;

            // handleArrowClasses(false, true, $prevArrow, $nextArrow);
        });
    });
});
